import { Button } from '@mui/material';
import './ConfirmScan.css';

const ConfirmScan = (props) => {
    const { value, handleConfirm, handleRetry } = props;

    return (
        <div className="confirmContainer">
            <div>
                <h1>Scanned value:</h1>
                <p>{value}</p>
            </div>
            <div className="buttonBox">
                <Button className="confirm" onClick={handleConfirm} color='success' size='large' variant='contained' fullWidth>Confirm</Button>
                <Button className="retry" onClick={handleRetry} color='error' size='large' variant='contained' fullWidth>Retry</Button>
            </div>
        </div>
    )
};

export default ConfirmScan;